import React, { useState, useEffect, useCallback } from 'react';
import { piezasData } from '../data/mock';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Piezas = () => {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % piezasData.length);
  }, []);

  const prev = () => {
    setCurrent((p) => (p - 1 + piezasData.length) % piezasData.length);
  };

  useEffect(() => {
    const interval = setInterval(next, 4000);
    return () => clearInterval(interval);
  }, [next]);

  return (
    <section id="piezas" className="py-16 lg:py-20 bg-gray-50" data-testid="piezas-section">
      <div className="container mx-auto px-6 lg:px-10 max-w-5xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Nuestros trabajos
          </h2>
        </div>

        {/* Carousel */}
        <div className="relative rounded-xl overflow-hidden border border-gray-200 shadow-lg bg-white">
          <div className="relative aspect-[3/2] sm:aspect-[16/9]">
            {piezasData.map((pieza, index) => (
              <img
                key={pieza.id}
                src={pieza.image}
                alt={pieza.alt}
                data-testid={`pieza-slide-${index}`}
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${
                  index === current ? 'opacity-100' : 'opacity-0'
                }`}
              />
            ))}

            {/* Arrows */}
            <button
              onClick={prev}
              aria-label="Pieza anterior"
              data-testid="pieza-prev-btn"
              className="absolute left-3 lg:left-5 top-1/2 -translate-y-1/2 z-10 p-2.5 rounded-full bg-white/80 hover:bg-[#0d3b66] text-[#0d3b66] hover:text-white backdrop-blur-sm border border-white/60 transition-all duration-300 group"
            >
              <ChevronLeft size={24} className="group-hover:scale-110 transition-transform" />
            </button>
            <button
              onClick={next}
              aria-label="Pieza siguiente"
              data-testid="pieza-next-btn"
              className="absolute right-3 lg:right-5 top-1/2 -translate-y-1/2 z-10 p-2.5 rounded-full bg-white/80 hover:bg-[#0d3b66] text-[#0d3b66] hover:text-white backdrop-blur-sm border border-white/60 transition-all duration-300 group"
            >
              <ChevronRight size={24} className="group-hover:scale-110 transition-transform" />
            </button>
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2.5 py-4">
            {piezasData.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrent(index)}
                aria-label={`Ir a pieza ${index + 1}`}
                data-testid={`pieza-dot-${index}`}
                className={`transition-all duration-300 rounded-full ${
                  index === current ? 'w-8 h-2.5 bg-[#0d3b66]' : 'w-2.5 h-2.5 bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Piezas;
